module.exports = {};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.iterators.js
 ** module id = 479
 ** module chunks = 1
 **/